
export const API_BASE_URL2 = "http://192.168.116.150:3001/api";
const PaywiseOn = true
export const paymenttitle='PayWise Payments'
export const PaywiseOnStatus =PaywiseOn;
export const API_BASE_URL = "https://api.paywisetech.africa/V2"
//export const API_BASE_URL ="http://localhost:5006/V2"
//export const API_BASE_URL ='http://192.168.1.66:3001'

